import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field, getIn, useFormikContext } from 'formik';
import { ButtonTooltip, FormikInput, Icon } from '../../../../components';

export const addWithPrecision = (...numbers) => {
  const factor = 100;
  const result = numbers.reduce((sum, num) => {
    return sum + Math.round((num || 0) * factor);
  }, 0);
  return result / factor;
};

function HolidayCompensation({ settlementSettings = [], viewOnly }) {
  const { values, errors, touched, setFieldValue } = useFormikContext();
  const modifyDetailVacationDays =
    settlementSettings.find(setting => setting.code === 'modify_detail_vacation_days')?.text_value === 'true';

  const legalVacationDays = +getIn(values, 'settlement[legalVacationDays]') || 0;
  const aditionalVacationDays = +getIn(values, 'settlement[aditionalVacationDays]') || 0;
  const progressiveVacationDays = +getIn(values, 'settlement[progressiveVacationDays]') || 0;
  const nonWorkingDays = +getIn(values, 'settlement[nonWorkingDays]') || 0;

  useEffect(() => {
    const totalDays = addWithPrecision(
      legalVacationDays,
      aditionalVacationDays,
      progressiveVacationDays,
      nonWorkingDays
    );
    setFieldValue('settlement[totalVacationDays]', totalDays.toFixed(2));
  }, [legalVacationDays, aditionalVacationDays, progressiveVacationDays, nonWorkingDays, setFieldValue]);

  return (
    <Col>
      <Row>
        <Col xl={1} md={1} lg={1} xs={12}>
          <Field name="settlement[legalVacationDays]">
            {({ field }) => (
              <FormikInput
                {...field}
                label="Legales"
                value={values?.settlement?.legalVacationDays || ''}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
                disabled={!modifyDetailVacationDays || viewOnly}
                style={{ minWidth: '65px' }}
              />
            )}
          </Field>
        </Col>
        <Col xs={1} lg={1} md={1} className="d-flex justify-content-center align-items-center">
          <ButtonTooltip variant="circle-primary" className="btn-circle" size="sm" text="Nuevo">
            <Icon icon="add" />
          </ButtonTooltip>
        </Col>
        <Col xl={1} md={1} lg={1} xs={12}>
          <Field name="settlement[aditionalVacationDays]">
            {({ field }) => (
              <FormikInput
                {...field}
                label="Adicionales"
                value={values?.settlement?.aditionalVacationDays || ''}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
                style={{ minWidth: '65px' }}
                disabled={!modifyDetailVacationDays || viewOnly}
              />
            )}
          </Field>
        </Col>
        <Col xs={1} lg={1} md={1} className="d-flex justify-content-center align-items-center">
          <ButtonTooltip variant="circle-primary" className="btn-circle" size="sm" text="Nuevo">
            <Icon icon="add" />
          </ButtonTooltip>
        </Col>
        <Col xl={1} md={1} lg={1} xs={12}>
          <Field name="settlement[progressiveVacationDays]">
            {({ field }) => (
              <FormikInput
                {...field}
                label="Progresivas"
                value={values?.settlement?.progressiveVacationDays || ''}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
                disabled={!modifyDetailVacationDays || viewOnly}
                style={{ minWidth: '65px' }}
              />
            )}
          </Field>
        </Col>
        <Col xs={1} lg={1} md={1} className="d-flex justify-content-center align-items-center">
          <ButtonTooltip variant="circle-primary" className="btn-circle" size="sm" text="Nuevo">
            <Icon icon="add" />
          </ButtonTooltip>
        </Col>
        <Col xl={1} md={1} lg={1} xs={12}>
          <Field name="settlement[nonWorkingDays]">
            {({ field }) => (
              <FormikInput
                {...field}
                label="Inhábiles"
                value={values?.settlement?.nonWorkingDays || ''}
                style={{ minWidth: '65px' }}
                type="number"
                disabled={!modifyDetailVacationDays || viewOnly}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={1} lg={1} md={1} className="d-flex justify-content-center align-items-center">
          <ButtonTooltip variant="circle-primary" className="btn-circle" size="sm" text="Nuevo">
            <Icon icon="add" />
          </ButtonTooltip>
        </Col>
        <Col xl={1} md={1} lg={1} xs={12}>
          <Field name="settlement[totalVacationDays]">
            {({ field }) => (
              <FormikInput
                {...field}
                label="Total"
                error={getIn(errors, field.name)}
                style={{ minWidth: '65px' }}
                touched={getIn(touched, field.name)}
                value={values?.settlement?.totalVacationDays || ''}
                readOnly
              />
            )}
          </Field>
        </Col>
      </Row>
    </Col>
  );
}

export default HolidayCompensation;
